import { PAYMENTS_DD_RECEIPT_PATH, PAYMENTS_RECEIPT_PATH } from '@shared/constants/paths';

export const PAYMENT_BILL_TYPE = { MANUAL: 'MANUAL', MANUAL_USER: 'MANUAL-USER' };

export const BILL_PAYMENT = 'BillPayment';
export const HHPAY = 'HHPAY';

export const UNKNOWN = 'Unknown';
export const TAB_QUERY_KEY = 'tab';
export const BILLS_HISTORY = {
  TAB_KEY: 'history',
  LABEL: 'History',
};
export const BILLS_CURRENT = {
  TAB_KEY: 'current',
  LABEL: 'Current',
};

// DocText
export const PAYMENT_2C2P_ERROR_LIST = 'PaymentService.2c2pErrorList';
export const PAYMENT_SERVICE_RECEIPT_SUCCESS = 'PaymentService.Receipt.Success';
export const PAYMENT_SERVICE_RECEIPT_PENDING = 'PaymentService.Receipt.Pending';

export const PG = 'PG';
export const PG_ERROR_LEN = 6;
export const COMMON_PAYMENT_RECEIPT_PAGES: string[] = [PAYMENTS_RECEIPT_PATH, PAYMENTS_DD_RECEIPT_PATH];
export const RECEIPT_MODE1 = 'mode=1';
